import Choices from "choices.js";

const buildSearchableSelect = ({
    searchPlaceholder = "Search…",
} = {}) => ({
    instance: null,
    open: false,

    init() {
        const select = this.$refs.select;

        if (!(select instanceof HTMLSelectElement)) {
            return;
        }

        this.instance = new Choices(select, {
            searchEnabled: true,
            searchChoices: true,
            shouldSort: false,
            allowHTML: false,
            itemSelectText: "",
            placeholder: true,
            searchPlaceholderValue: searchPlaceholder,
            position: "auto",
        });

        if (select.disabled) {
            this.instance.disable();
        }

        const element = this.instance.passedElement.element;

        element.addEventListener("showDropdown", () => {
            this.open = true;
        });

        element.addEventListener("hideDropdown", () => {
            this.open = false;
        });
    },

    destroy() {
        this.instance?.destroy();
        this.instance = null;
    },
});

export const registerSearchableSelect = (Alpine) => {
    Alpine.data("searchableSelect", (config) => buildSearchableSelect(config));
};
